function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import $ from 'jquery';
import { CreateAddressForm, EditAddressForm } from './../../components/addresses';
export var ATTR_INDEX = 'data-index';
export var SELECTOR_ADDRESSES_TEMPLATE = '[data-addresses-template]';
export var SELECTOR_CREATE_ADDRESS = '[data-addresses-template-create]';
export var SELECTOR_EDIT_ADDRESS = '[data-address-template-edit]';
export var LOYALTY_POINTS = '[data-loyalty-points]';
export var SELECTOR_TOGGLE_CREATE_FORM = '[data-address-create-toggle]';
export var SELECTOR_HIDE_CREATE_FORM = '[data-address-create-hide]';
export var SELECTOR_DELETE_ADDRESS = '[data-address-delete]';
export var SELECTOR_TOGGLE_EDIT_FORM = '[data-address-edit-toggle]';
export var SELECTOR_HIDE_EDIT_FORM = '[data-address-edit-hide]';
export var CLASS_VISIBLE = 'is-visible';
var AddressesTemplate = /*#__PURE__*/function () {
  function AddressesTemplate(container) {
    var _this = this;
    _classCallCheck(this, AddressesTemplate);
    this.container = container;

    //Create address form wrapper
    this.createForms = [];
    this.editForms = [];
    this.points = container.find(LOYALTY_POINTS);
    $(SELECTOR_CREATE_ADDRESS).each(function (i, e) {
      var self = $(e);
      var form = new CreateAddressForm(self);
      _this.createForms.push(form);
    });
    $(SELECTOR_EDIT_ADDRESS).each(function (i, e) {
      var self = $(e);
      var form = new EditAddressForm(self);
      _this.editForms.push(form);
    });
    this.container.on('click', SELECTOR_TOGGLE_CREATE_FORM, function (e) {
      return _this.onToggleCreateForm(e);
    });
    this.container.on('click', SELECTOR_HIDE_CREATE_FORM, function (e) {
      return _this.onHideCreateForm(e);
    });
    this.container.on('click', SELECTOR_DELETE_ADDRESS, function (e) {
      return _this.onDeleteAddress(e);
    });
    this.container.on('click', SELECTOR_TOGGLE_EDIT_FORM, function (e) {
      return _this.onToggleEditForm(e);
    });
    this.container.on('click', SELECTOR_HIDE_EDIT_FORM, function (e) {
      return _this.onHideEditForm(e);
    });

    //Check to see if LL has initialised
    this.loyaltyLionCheck = setInterval(function () {
      return _this.checkLoyaltyLion();
    }, 100);
  }
  _createClass(AddressesTemplate, [{
    key: "checkLoyaltyLion",
    value: function checkLoyaltyLion() {
      // Do we have the required data from Loyalty Lion ready?
      if (!window.loyaltylion.customer) return;
      // clear the interval to stop the function from being called
      clearInterval(this.loyaltyLionCheck);
      this.currentPoints = window.loyaltylion.customer.pointsApproved;
      if (this.points.length) this.points.html(this.currentPoints);
    }
  }, {
    key: "onToggleCreateForm",
    value: function onToggleCreateForm(e) {
      e.preventDefault();
      e.stopPropagation();
      this.container.find(SELECTOR_CREATE_ADDRESS).toggleClass(CLASS_VISIBLE);
    }
  }, {
    key: "onHideCreateForm",
    value: function onHideCreateForm(e) {
      e.preventDefault();
      e.stopPropagation();
      this.container.find(SELECTOR_CREATE_ADDRESS).removeClass(CLASS_VISIBLE);
    }
  }, {
    key: "onDeleteAddress",
    value: function onDeleteAddress(e) {
      var self = $(e.currentTarget);
      var id = self.attr('data-id');
      if (!id) return;
      if (confirm(window.Language.strings['customer.addresses.delete_confirm'])) {
        Shopify.postLink("/account/addresses/".concat(id), {
          parameters: {
            _method: 'delete'
          }
        });
      }
    }
  }, {
    key: "onToggleEditForm",
    value: function onToggleEditForm(e) {
      e.preventDefault();
      e.stopPropagation();
      var self = $(e.currentTarget);
      var id = self.attr(ATTR_INDEX);
      var form = this.container.find("".concat(SELECTOR_EDIT_ADDRESS, "[").concat(ATTR_INDEX, "=\"").concat(id, "\"]"));
      form.toggleClass(CLASS_VISIBLE);
    }
  }, {
    key: "onHideEditForm",
    value: function onHideEditForm(e) {
      e.preventDefault();
      e.stopPropagation();
      var self = $(e.currentTarget);
      self.closest(SELECTOR_EDIT_ADDRESS).removeClass(CLASS_VISIBLE);
    }
  }]);
  return AddressesTemplate;
}();
$(document).ready(function () {
  $(SELECTOR_ADDRESSES_TEMPLATE).each(function (i, e) {
    new AddressesTemplate($(e));
  });
});